export class RolePermissionsType {
    public static ADMINISTRATOR = "a";

    public static PUBLISHER_ADMINISTRATOR = "pa";
    public static PUBLISHER_PUBLISH = "be";
    public static PUBLISHER = "p";
    public static PUBLISHER_FACEBOOK_READ = "ba";
    public static PUBLISHER_INSTAGRAM_PAGE_READ = "bb";
    public static PUBLISHER_TWITTER_READ = "bc";
    public static PUBLISHER_LINKEDIN_READ = "bf";

    public static ACCOUNT_MANAGE = "g";
    public static INVITATIONS_MANAGE = "k";
    public static ROLES_MANAGE = "n";
    public static TECHNICAL_MANAGE = "bn";

    public static BLOG_ADMINISTRATOR = "bi";
    public static BLOG_READING = "bj";
    public static BLOG_WRITING = "bk";
    public static BLOG_PUBLISH = "bt";
    public static BLOG_DELETE = "bl";

    public static INBOX_READING = "bo";
    public static INBOX_REPLY = "bp";

    public static ESTABLISHMENT_READING = "bq";
    public static ESTABLISHMENT_WRITING = "br";
    public static ESTABLISHMENT_IDENTITY = "bs";

    public static SUBSCRIPTION_ADMINISTRATOR = "bm";

    public static WHITE_LABEL = "wl";

    public static DISABLE_AGENT_ALYA = "da";
    public static DISABLE_AGENT_REMI = "db";
    public static DISABLE_AGENT_MAYA = "dc";
    public static DISABLE_AGENT_NOX = "dd";
    public static DISABLE_AGENT_MARC = "dm";
    public static DISABLE_AGENT_LUCA = "dp";
    public static DISABLE_AGENT_MAX = "dq";
    public static DISABLE_SEO_VISIBILITY = "de";
    public static DISABLE_LLM_VISIBILITY = "dn";
    public static DISABLE_LOCAL_VISIBILITY = "dr";
    public static DISABLE_TOOLS = "df";
    public static DISABLE_IMAGES_EDIT = "dg";
    public static DISABLE_ONBOARDING_VIDEO = "dh";
    public static DISABLE_HELP_CENTER = "di";
    public static DISABLE_INDEXATION = "do";
    public static DISABLE_SITE_CONFIG_CONNECTIONS = "dj";
    public static DISABLE_SITE_CONFIG_BRAND = "dk";
    public static DISABLE_SITE_CONFIG_SETTINGS = "dl";
}